import { isLiveSite } from "@/lib/siteConfig";

export const STORE_LIVE = process.env.NEXT_PUBLIC_STORE_LIVE === "true";

export const STORE_VISIBLE = STORE_LIVE || !isLiveSite;
